const couponDetails = (state = null, action) => {
    if (action.type === "SET_COUPON_DETAILS") {
        return action.payload;
    } else {
        return state;
    }
};

export default couponDetails;
